import { createContext } from "react";

export const NomContext = createContext([]);